import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import './CandidatesToolbarSkeleton.css';

const CandidatesToolbarSkeleton: React.FC = () => (
  <div
    className="candidate-list-toolbar card border-0 rounded-4"
    style={{
      background: "#fff",
      border: "1px solid #e8edf5",
      boxShadow: "0 10px 30px rgba(15,23,42,0.04)",
      padding: "16px",
    }}
  >
    {/* Row 1 — job pills */}
    <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 14 }}>
      <Skeleton width={72}  height={34} borderRadius={999} />
      <Skeleton width={130} height={34} borderRadius={999} />
      <Skeleton width={90}  height={34} borderRadius={999} />
      <Skeleton width={140} height={34} borderRadius={999} />
      <Skeleton width={130} height={34} borderRadius={999} />
    </div>

    {/* divider */}
    <div style={{ borderTop: "1px solid #edf1f7", marginBottom: 14 }} />

    {/* Row 2 — search left · sort + filter right */}
    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
      {/* search bar */}
      <Skeleton width={200} height={38} borderRadius={10} />

      {/* sort + filter */}
      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
        <Skeleton width={110} height={38} borderRadius={999} />
        <Skeleton width={90}  height={38} borderRadius={999} />
      </div>
    </div>
  </div>
);

export default CandidatesToolbarSkeleton;
